const CHECKBOX_VARIANTS = {
    single: 'single',
    multiple: 'multiple',
    expandable: 'expandable',
};

export default CHECKBOX_VARIANTS;
